import { getAndMergeNodeIdsFromFlowItems, isCondExpForbiddenOnConnector, toFlowMergeRefs } from '../../utility/helpers/AndMergeForkHelpers';
import { getFlowConnectorConfig } from '../../utility/helpers';
import { JourneyCanvasState } from '../../utility/TypeDefs';
import { CondExpSavePayload } from '../TypeDefs';

/**
 * @method condExpSave
 * @description Saves the conditional expression and updates the state of the journey canvas.
 * @param {JourneyCanvasState} state - The current state of the journey canvas.
 * @param {CondExpSavePayload} payload - The payload containing the expr, exprBuilderStr, and nodeId.
 * @returns {JourneyCanvasState} The updated state of the journey canvas.
 */
export const condExpSave = (state: JourneyCanvasState, { expr, exprBuilderStr, toNodeId, fromNodeId }: CondExpSavePayload): JourneyCanvasState => {
  const andMergeNodeIds = getAndMergeNodeIdsFromFlowItems(state.flowItems);
  if (isCondExpForbiddenOnConnector(fromNodeId, toNodeId, state.flowConnectors, andMergeNodeIds, toFlowMergeRefs(state.flowItems))) {
    return state;
  }
  const connector = state.flowConnectors.find((c) => c.toNodeId === toNodeId && c.fromNodeId === fromNodeId);
  if (!connector) {
    return state;
  }
  connector.config = getFlowConnectorConfig({
    hasCondExpr: !!expr,
    mep: !!state.flowItemDataMap[connector.toNodeId]?.isExternal,
    external: !!state.flowItemDataMap[connector.fromNodeId]?.isExternal
  });

  const condExpr = { ...state.flowItemDataMap[toNodeId].condExpr };
  if (!expr && !exprBuilderStr) {
    delete condExpr[fromNodeId];
  } else {
    condExpr[fromNodeId] = {
      rawExpression: expr ?? '',
      builderExpression: exprBuilderStr ?? ''
    };
  }

  return {
    ...state,
    flowItemDataMap: {
      ...state.flowItemDataMap,
      [toNodeId]: {
        ...state.flowItemDataMap[toNodeId],
        condExpr
      }
    },
    showCondExpModal: false,
    flowConnectors: [...state.flowConnectors]
  };
};
